import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { ActiveBookingIntent } from '@models';
import { BehaviorSubject, Observable, shareReplay, switchMap } from 'rxjs';

@Injectable()
export class ActiveBookingIntentService extends HttpService<ActiveBookingIntent> {
  protected override collectionPath = '/booking-intents/active';

  private readonly reload$ = new BehaviorSubject<void>(undefined);

  private readonly activeBookingIntent$ = this.reload$.pipe(
    switchMap(() => this.http.get<ActiveBookingIntent>(this.apiUrl)),
    shareReplay(1)
  );

  getBookingIntentData(): Observable<ActiveBookingIntent> {
    return this.activeBookingIntent$;
  }

  reload(): void {
    this.reload$.next();
  }
}
